import cn from 'classnames';
import React from 'react';
import {useSelector} from 'react-redux';

import mwConnectionService from '@/services/mw/mwConnectionService';
import mwFwuService from '@/services/mw/mwFwuService';
import {selectIsSelectedDeviceConnectedToIot} from '@/state/selectors/device';
import {selectIsFwuAvailable} from '@/state/selectors/fwu';

const FirmwareUpdateTest = () => {
    const isFwuAvailable = useSelector(selectIsFwuAvailable);
    const isDeviceConnected = useSelector(selectIsSelectedDeviceConnectedToIot);

    if (!isFwuAvailable) return;

    return (
        <div className='border-gray-200 mt-4 border-b border-t py-4'>
            <h3 className='text-lg text-gray-900 mb-3 font-semibold'>Firmware Update Test</h3>
            <div className='flex gap-2'>
                <button
                    onClick={() => mwFwuService.startFwu()}
                    className={cn(
                        'border-gray-300 cursor-pointer rounded border bg-tertiary px-1 py-0.5 text-12 text-primary transition-colors'
                    )}
                >
                    Start FWU
                </button>
                {!isDeviceConnected && (
                    <button
                        onClick={() => {
                            mwConnectionService.initDeviceConnection({
                                isReconnect: true,
                            });
                        }}
                        className={cn(
                            'border-gray-300 cursor-pointer rounded border bg-tertiary px-1 py-0.5 text-12 text-primary transition-colors'
                        )}
                    >
                        Reconnect
                    </button>
                )}
            </div>
        </div>
    );
};

export default FirmwareUpdateTest;
